import React from 'react';
import AuthService from 'services/AuthService';
import { Link, useLocation, useHistory } from 'react-router-dom';
import withContext from 'context/withContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortDown } from '@fortawesome/free-solid-svg-icons';
import { RoutesBase } from 'routes/constants-routes';
import { IContext } from 'context/reducers';

type Props = {
  context: IContext;
};

const HeaderLogin: React.FC<Props> = props => {
  const Auth = new AuthService();
  const location = useLocation();
  const history = useHistory();
  function logout() {
    const { dispatch } = props.context;
    Auth.logout();
    dispatch({
      type: 'LOGIN_CHANGED',
      isUserLogged: false,
    });
    history.push(location.pathname);
  }

  const isLogged = Auth.loggedIn();
  const { primeiroNome } = isLogged && Auth.getClient();

  const isMinhasViagens =
    window.location.pathname.indexOf(`/${RoutesBase.myTravels.list}`) !== -1;
  /*  eslint-disable jsx-a11y/anchor-is-valid */

  return (
    <>
      {isLogged ? (
        <>
          <li className="nav-item">
            <Link
              className={`nav-link new-link ${isMinhasViagens ? 'isChecked' : ''}`}
              to={`/${RoutesBase.myTravels.list}`}
            >
              Minhas Viagens
            </Link>
          </li>
          <li className="nav-item">
            <div id="HeaderLogin">
              <div className="dropdown nav-logado">
                <a
                  className="nav-link d-inline"
                  id="dropdownMenu2"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span>Bem vindo,</span>
                  <div className="titleDown">
                    <p>{primeiroNome && primeiroNome.split(' ')[0]}</p>
                    <FontAwesomeIcon icon={faSortDown} />
                  </div>
                </a>
                <div
                  className="dropdown-menu dropdown-menu-right"
                  aria-labelledby="dropdownMenu2"
                >
                  <Link
                    className="dropdown-item"
                    to={`/${RoutesBase.myAccount.informations}`}
                  >
                    Minha conta
                  </Link>
                  <Link
                    className="dropdown-item"
                    to={`/${RoutesBase.myTravels.list}`}
                  >
                    Minhas Viagens
                  </Link>
                  <a className="dropdown-item" onClick={logout}>
                    Sair
                  </a>
                </div>
              </div>
            </div>
          </li>
        </>
      ) : (
        <>
          <li className="nav-item d-none d-md-none d-lg-block">
            <div id="HeaderLogin">
              <Link
                className="nav-link"
                to={{
                  pathname: `/${RoutesBase.login}`,
                  state: {
                    from: location,
                  },
                }}
              >
                Cadastre-se
              </Link>
            </div>
          </li>

          <li className="nav-item">
            <div id="HeaderLogin">
              <Link
                className="nav-link"
                to={{
                  pathname: `/${RoutesBase.login}/acesso`,
                  state: {
                    from: location,
                  },
                }}
              >
                Acessar
              </Link>
            </div>
          </li>
        </>
      )}
    </>
  );
};

export default React.memo(withContext(HeaderLogin));
